// Route Pages
const VerifyConfirm = () => import('../../../components/common/pages/VerifyConfirm.vue')
const VerifyEmail = () => import('../../../components/common/pages/VerifyEmail.vue')
const VerifyWarning = () => import('../../../components/common/pages/VerifyWarning.vue')
const VerificationCode = () => import('../../../components/common/pages/VerificationCode.vue')
const VerificationMethod = () => import('../../../components/common/pages/VerificationMethod.vue')

export default () => {
  return [
    {
      path: '',
      name: 'VerifyWarning',
      component: VerifyWarning,
      props: true
    },
    {
      path: 'Email',
      name: 'VerifyEmail',
      component: VerifyEmail,
      props: true
    },
    {
      path: 'Code',
      name: 'RegisterVerificationCode',
      component: VerificationCode,
      props: true
    },
    {
      path: 'VerificationMethod',
      name: 'RegisterVerificationMethod',
      component: VerificationMethod,
      props: true
    },
    {
      path: 'Confirm',
      name: 'VerifyConfirm',
      component: VerifyConfirm,
      props: true
    }
  ]
}
